import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { LeadSubtypePermissionModel, RenaultLeadDashBoard, RenaultLeadDashBoardV16, RenaultLeadDTO, RenaultLeadFilter, RenaultLeadHighLights, RenaultLeadMessageDTO, RenaultLeadPostDTO, SalesforceSubmissionResultDTO } from '../models/renault-lead-dto';
import { Select2Data } from 'ng-select2-component';
import { LeadPermissionModel } from '../models/lead-permission';
import { DistributorParams } from '../models/shared-dto';
import { RenaultLeadEmailConfigurationDTO, RenaultLeadEmailConfigurationTableDTO } from '../models/renault-lead-email-configuration-dto';

@Injectable({
  providedIn: 'root'
})

export class LeadService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultLead/";
  filter: RenaultLeadFilter;

  constructor(private http: HttpClient) { }

  setFilter(filter: RenaultLeadFilter) {
    this.filter = filter;
  }

  getFilter(): RenaultLeadFilter {
    return this.filter;
  }

  public get(id: string): Observable<RenaultLeadDTO> {
    return this.http.get<RenaultLeadDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: RenaultLeadPostDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public updateLeadVn(idLead: string, data: RenaultLeadPostDTO, sendMail: boolean = true): Observable<any> {
    return this.http.put<any>(`${this.pathAPI}${this.controller}UpdateLeadVn/${idLead}?sendMail=${sendMail}`, data);
  }

  public postMessage(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + "PostMessage", data);
  }

  public getMessage(id: string): Observable<RenaultLeadMessageDTO> {
    return this.http.get<RenaultLeadMessageDTO>(this.pathAPI + this.controller + 'GetMessage/' + id);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any, filter): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + filter, data);
  }

  public getDataTablePermission(): Observable<LeadPermissionModel> {
    return this.http.get<LeadPermissionModel>(this.pathAPI + this.controller + "GetDataTablePermission");
  }

  public GetPermissionList(): Observable<LeadSubtypePermissionModel[]> {
    return this.http.get<LeadSubtypePermissionModel[]>(this.pathAPI + this.controller + "GetPermissionList");
  }

  public getLeadsStatus(isFilter): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetLeadsStatus/' + isFilter);
  }

  public getLeadsTypes(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetLeadsTypes');
  }

  public getLeadsTypesEncrypt(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetLeadsTypesEncrypt');
  }

  public getLeadTypeById(id: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetLeadTypeById/' + id);
  }

  public getBrands(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetBrands');
  }

  public getLeadBrands(brandIds: number[]): Observable<any> {
    const params = brandIds.map(id => `brandIds=${id}`).join('&');
    return this.http.get<any>(`${this.pathAPI}${this.controller}GetLeadBrands?${params}`);
  }

  public getSources(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetSources');
  }

  public getLeadsSubtypes(create: boolean, idType: number): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetLeadsSubtypes/' + create + "/" + idType);
  }

  public getAgents(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'GetAgents');
  }

  public getYears(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetYears');
  }

  public getMonths(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetMonths');
  }

  public getAccountNumbers(isFilter, idSubtype: number = null): Observable<Select2Data> {
    let endpoint = this.pathAPI + this.controller + 'GetAccountNumbers/' + isFilter;
    if (idSubtype !== null && idSubtype !== undefined) {
      endpoint += '?idSubtype=' + idSubtype;
    }
    return this.http.get<Select2Data>(endpoint);
  }

  public getHighLights(filter): Observable<RenaultLeadHighLights> {
    return this.http.get<RenaultLeadHighLights>(this.pathAPI + this.controller + 'GetHighlights/' + filter);
  }

  public getDashboard(filter): Observable<RenaultLeadDashBoard> {
    return this.http.get<RenaultLeadDashBoard>(this.pathAPI + this.controller + 'GetDashboard/' + filter);
  }

 /* public GetDashboardChartResponseTimeLead(filter): Observable<RenaultLeadDashBoard> {
    return this.http.get<RenaultLeadDashBoard>(this.pathAPI + this.controller + 'GetDashboardChartResponseTimeLead/' + filter);
  }*/

  public GetDashboardChartResponseTimeReclamacion(filter): Observable<RenaultLeadDashBoard> {
    return this.http.get<RenaultLeadDashBoard>(this.pathAPI + this.controller + 'GetDashboardChartResponseTimeReclamacion/' + filter);
  }

  public getDashboardR2(filter: string, idR2: number = null): Observable<RenaultLeadDashBoard> {
    let endpoint = this.pathAPI + this.controller + 'GetDashboardR2/' + filter;
    if (idR2 !== null && idR2 !== undefined) {
      endpoint += '?idR2=' + idR2;
    }
    return this.http.get<RenaultLeadDashBoard>(endpoint);
  }

  public getDashboardV16(filter: string): Observable<RenaultLeadDashBoardV16> {
    return this.http.get<RenaultLeadDashBoardV16>(this.pathAPI + this.controller + 'GetDashboardV16/' + filter);
  }

  public triggerV16Export(): Observable<any> {
    return this.http.post(this.pathAPI + this.controller + 'TriggerV16Export', {});
  }

  public getDashboardR2Late(filter: string, idR2: number = null): Observable<RenaultLeadDashBoard> {
    let endpoint = this.pathAPI + this.controller + 'GetDashboardR2Late/' + filter;
    if (idR2 !== null && idR2 !== undefined) {
      endpoint += '?idR2=' + idR2;
    }
    return this.http.get<RenaultLeadDashBoard>(endpoint);
  }


  downloadExcel(filter): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetFileExcel/' + filter;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  downloadExcelReclamaciones(filter): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetLeadsReclamacionesExcel/' + filter;
    return this.http.post<Blob>(endpoint, null, requestOptions);
  }

  public calculateEmailConfiguration(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'CalculateEmailConfiguration');
  }

  public getEmailConfigurationByDistributor(param: DistributorParams): Observable<RenaultLeadEmailConfigurationTableDTO[]> {
      return this.http.post<RenaultLeadEmailConfigurationTableDTO[]>(this.pathAPI + this.controller + 'GetEmailConfigurationByDistributor/', param);
    }
  
  public saveEmailConfiguration(data: RenaultLeadEmailConfigurationDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'SaveEmailConfiguration', data);
  }

}
